export const FLAG_GETTING_IN_SYSTEM_NOTIFICATIONS =
  'FLAG_GETTING_IN_SYSTEM_NOTIFICATIONS';
export const GET_IN_SYSTEM_NOTIFICATIONS = 'GET_IN_SYSTEM_NOTIFICATIONS';
export const CLEAR_IN_SYSTEM_NOTIFICATIONS = 'CLEAR_IN_SYSTEM_NOTIFICATIONS';
export const FLAG_IN_SYSTEM_NOTIFICATION_ACTIVITY =
  'FLAG_IN_SYSTEM_NOTIFICATION_ACTIVITY';
export const GET_IN_SYSTEM_NOTIFICATION = 'GET_IN_SYSTEM_NOTIFICATION';
export const CLEAR_IN_SYSTEM_NOTIFICATION = 'CLEAR_IN_SYSTEM_NOTIFICATION';
